export default __webpack_public_path__ + "static/media/noun-administration-2872961.b1feb9b5.svg";